export const TOGGLE_PRODUCTS_IS_LOADING = "TOGGLE_PRODUCTS_IS_LOADING"
export const SET_PRODUCTS = "SET_PRODUCTS"
export const TOGGLE_OPTION_DOUGH = "TOGGLE_OPTION_DOUGH"
export const TOGGLE_OPTION_SIZE = "TOGGLE_OPTION_SIZE"

//cart

export const ADD_PRODUCT_IN_CART = "ADD_PRODUCT_IN_CART"
export const REMOVE_PRODUCT_IN_CART = "REMOVE_PRODUCT_IN_CART"
export const REMOVE_ALL_PRODUCTS_IN_CART = "REMOVE_ALL_PRODUCTS_IN_CART"
export const INCREMENT_TOTAL_COUNT = "INCREMENT_TOTAL_COUNT"
export const DECREMENT_TOTAL_COUNT = "DECREMENT_TOTAL_COUNT"

// sort
export const SET_ACTIVE_FILTER = "SET_ACTIVE_FILTER"
export const SET_ACTIVE_SORT = "SET_ACTIVE_SORT"
